// extracted by mini-css-extract-plugin
module.exports = {"s1r2ig8a":"s1r2ig8a","shimmer-s1r2ig8a":"shimmer-s1r2ig8a"};